import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';

type DownloadButtonProps = {
  onClick: () => void;
};

export const DownloadButton = (props: DownloadButtonProps) => {
  return (
    <IconButton color="primary" sx={{ margin: 'auto' }} onClick={props.onClick}>
      <FontAwesomeIcon
        icon={faArrowDownToBracket}
        style={{ height: '1.5rem' }}
      />
    </IconButton>
  );
};
